import React from 'react'

export const Reply = () => (
  <svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect x="0.75" y="0.75" width="26.5" height="26.5" rx="13.25" fill="white" />
    <g clipPath="url(#clip0_213_3995)">
      <path
        d="M4 14C4 19.5226 8.4774 24 14 24C19.5226 24 24 19.5226 24 14C24 8.4774 19.5226 4 14 4C8.4774 4 4 8.4774 4 14ZM8.71154 18.2308C8.71154 14.9553 9.80144 11.6375 14.4409 11.6375V9L19.2885 13.6154L14.4409 18.2308V15.5933C11.2346 15.5933 10.0505 16.5207 8.71154 18.2308Z"
        fill="black"
      />
    </g>
    <rect x="0.75" y="0.75" width="26.5" height="26.5" rx="13.25" stroke="black" strokeWidth="1.5" />
    <defs>
      <clipPath id="clip0_213_3995">
        <rect width="20" height="20" fill="white" transform="translate(4 4)" />
      </clipPath>
    </defs>
  </svg>
)
